module.exports = __webpack_public_path__ + "static/media/search_icon.9d3b8c4d.png";